import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { computed } from 'vue';

interface Props {
  level: number;
  expiresAt?: string | null;
  type?: 'default' | 'mini'; // mini用于导航栏等小型显示
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VipBadge',
  props: {
    level: {},
    expiresAt: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

const isVip = computed(() => props.level > 0);

const vipTooltip = computed(() => {
  if (!isVip.value) return '普通用户';
  if (!props.expiresAt) return 'VIP用户';
  return `VIP用户 - 到期时间: ${new Date(props.expiresAt).toLocaleDateString('zh-CN')}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["vip-badge", { 'is-vip': isVip.value, 'is-mini': _ctx.type === 'mini' }]),
    title: vipTooltip.value
  }, _toDisplayString(isVip.value ? 'VIP' : '普通用户'), 11, _hoisted_1))
}
}

})